module.exports = __webpack_public_path__ + "assets/img/4-6.b7ba63f5.png";